import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

const app = createApp(App);

import {
  ElInput,
  ElSelect,
  ElTable,
  ElForm,
  dayjs,
  ElMessage,
} from "element-plus";

ElInput.props.autosize = { type: Object, default: { minRows: 4 } }; //多行文本框默认4行

ElSelect.props.filterable = { type: Boolean, default: true }; //下拉框默认可输入筛选
ElSelect.props.clearable = { type: Boolean, default: true }; //设置默认可清空

ElTable.props.className = { type: String, default: "tabCss" }; //设置列表样式
ElTable.props.size = { type: String, default: "large" };

ElForm.props.labelWidth = { type: String, default: "auto" };
ElForm.props.size = { type: String, default: "large" };

//#region 加载element ui
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";

//配置element图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.config.globalProperties[key] = key;
  app.component(key, component);
}
//#endregion

//#endregion

// 进度条配置
import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({
  showSpinner: false,
});

//#region 路由拦截
router.beforeEach((to, from, next) => {
  NProgress.start();
  //   next();
  if (to.path === "/login") {
    next();
  } else {
    let token = localStorage.getItem("token");
    if (token) {
      next();
    } else {
      next({
        path: "/login",
      });
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
//#endregion

//#region 注册通用组件

//#region 注入分页控件模板
import c_page from "@/components/Page.vue";
app.component("c_page", c_page);
//#endregion

//#region 注入弹窗控件模板
import c_popup from "@/components/Popup.vue";
app.component("c_popup", c_popup);
//#endregion

//#region 注入状态模板
import c_status from "@/components/Status.vue";
app.component("c_status", c_status);
//#endregion

//#region 注入金额模板
import c_money from "@/components/Money.vue";
app.component("c_money", c_money);
//#endregion

//#region 表格行内显示两行内容
import c_tabgroup from "@/components/TabGroup.vue";
app.component("c_tabgroup", c_tabgroup);
//#endregion

//#region 状态数组单选组件
import c_statusradiogroup from "@/components/StatusRadioGroup.vue";
app.component("c_statusradiogroup", c_statusradiogroup);
//#endregion

//#region 注入富文本编辑器模板
// import c_editor from "@/components/WangEditor.vue";
// app.component("c_editor", c_editor);
//#endregion

//#region 注册全部组件
const requireComponent = require.context("./views", true, /\.vue$/);
requireComponent.keys().forEach((fileName) => {
  // 当前组件
  const config = requireComponent(fileName);
  //获取组件名
  const componentName =
    "c_" +
    fileName
      .replace(/^\.\//, "")
      .replace(/\.\w+$/, "")
      .replace("/", ""); // 第一个replace(/^\.\//, '')去掉前面的./   第二个replace(/\.W+$/)是去掉后面的.vue

  store.commit("setCompontents", componentName);
  // 参数一： 组件名
  // 参数二： config：是一整个组件的内容；  config.default：是组件中export.default里面的内容
  app.component(componentName, config.default || config);
});
//#endregion

//#endregion 注册全局对象
app.config.globalProperties.$store = store;

import { $http } from "@/http";
app.config.globalProperties.$http = $http;

app.config.globalProperties.$dayjs = dayjs;

//常量对象（存储数据状态）
import constant from "@/utils/constant";
app.config.globalProperties.$constant = constant;

import {
  tab_Highlinght,
  tab_HighlinghtHtml,
  tab_TextFormat,
  tab_PriceFormat,
  tab_BuildGroup,
  tab_GroupFormat,
  tab_NumberFormat,
  tab_MoneyFormat,
  tab_ShowToolTip,
} from "@/utils/tFormat";
app.config.globalProperties.$tab_Highlinght = tab_Highlinght;
app.config.globalProperties.$tab_HighlinghtHtml = tab_HighlinghtHtml;
app.config.globalProperties.$tab_TextFormat = tab_TextFormat;
app.config.globalProperties.$tab_PriceFormat = tab_PriceFormat;
app.config.globalProperties.$tab_BuildGroup = tab_BuildGroup;
app.config.globalProperties.$tab_GroupFormat = tab_GroupFormat;
app.config.globalProperties.$tab_NumberFormat = tab_NumberFormat;
app.config.globalProperties.$tab_MoneyFormat = tab_MoneyFormat;
app.config.globalProperties.$tab_ShowToolTip = tab_ShowToolTip;

import {
  numberFormat,
  priceFormat,
  judge_auth,
  statusFormat,
  statusFormat2,
  judgeNumber,
  numberIsNullOrZero,
  showToolTip,
} from "@/utils/qFormat";
app.config.globalProperties.$numberIsNullOrZero = numberIsNullOrZero;
app.config.globalProperties.$judgeNumber = judgeNumber;
app.config.globalProperties.$numberFormat = numberFormat;
app.config.globalProperties.$priceFormat = priceFormat;
app.config.globalProperties.$judge_auth = judge_auth;
app.config.globalProperties.$statusFormat = statusFormat;
app.config.globalProperties.$statusFormat2 = statusFormat2;
app.config.globalProperties.$showToolTip = showToolTip;
//#endregion

app.config.globalProperties.$window = window;

app.config.globalProperties.$onCopy = (value) => {
  if (value == null || value == undefined) return false;

  try {
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard 向剪贴板写文本
      navigator.clipboard.writeText(value);
    } else {
      // 创建text area
      let textArea = document.createElement("textarea");
      textArea.value = value;
      // 使text area不在viewport，同时设置不可见
      textArea.style.position = "absolute";
      textArea.style.opacity = 0;
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand("copy");
      textArea.remove();
    }
    ElMessage({
      type: "success",
      message: "已复制",
      grouping: true,
    });
  } catch (err) {
    ElMessage({
      type: "error",
      message: "复制失败",
      grouping: true,
    });
  }
};

app
  .use(store)
  .use(router)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .mount("#app");
